export default "__VITE_ASSET__d00c157f__"